<div class="rmd-noti-dialog">

  <div class="rmd-noti-dialog__head">
    <div class="rmd-noti-dialog__title">
      {{ (data.notification.titulo || 'NOTIFICACIÓN') | uppercase }}
    </div>

    <button type="button" class="rmd-noti-dialog__close" (click)="close()">
      <i class="material-icons-outlined">close</i>
    </button>
  </div>

  <div class="rmd-noti-dialog__body">
    <div class="rmd-noti-dialog__block">
      <div class="rmd-noti-dialog__label">PACIENTE</div>
      <div class="rmd-noti-dialog__value">
        {{ (data.notification.nombrePaciente || 'N/A') | uppercase }}
      </div>
    </div>

    <div class="rmd-noti-dialog__block">
      <div class="rmd-noti-dialog__label">MENSAJE</div>
      <div class="rmd-noti-dialog__value rmd-noti-dialog__message">
        {{ (data.notification.mensaje || '') | uppercase }}
      </div>
    </div>
  </div>

  <div class="rmd-noti-dialog__footer">
    <button mat-flat-button class="rmd-btn-primary" (click)="close()">
      CERRAR
    </button>
  </div>

</div>
